export default __webpack_public_path__ + "static/1286-38c8b26ced17a86681b98f6ae5fd467b.gif";